module.exports = "/images/logo_Quattroruote.png?8ce26229d4181c4b55f0fd8297ce2b90";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/logo_Quattroruote.png
// module id = fuuZ
// module chunks = 1